import * as React from 'react';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Box, useTheme } from '@ttoss/ui';

import type { MyTheme } from '../../providers/ThemeProvider/theme';

import * as tooltipProps from '../ChartTooltip/tooltipProps';

export type ChartSoilWaterStorageProps = {
  data: {
    month: number;
    monthLabel: string;
    soilWaterStorageVolume: number;
  }[];
};

const ChartSoilWaterStorage = ({ data }: ChartSoilWaterStorageProps) => {
  const themeContext = useTheme();

  const theme = themeContext.theme as MyTheme;

  return (
    <Box style={{ width: '100%', height: theme.space[13] }}>
      <ResponsiveContainer width="100%" debounce={1}>
        <BarChart
          data={data}
          margin={{
            top: theme.space[6],
            right: theme.space[7],
            bottom: theme.space[6],
            left: theme.space[0],
          }}
          barCategoryGap={0}
          barGap={0}
        >
          <XAxis
            dataKey="monthLabel"
            tickLine={false}
            fontSize={theme.fontSizes[1]}
          />
          <YAxis
            yAxisId="soilWaterStorageVolume"
            type="number"
            axisLine={false}
            reversed={true}
            unit=" mm"
            interval={2}
            domain={['dataMin', 'dataMax']}
            tickLine={false}
            fontSize={theme.fontSizes[1]}
            allowDecimals={false}
            tickFormatter={(value) => Math.round(value).toString()}
          />
          <Bar
            name="Armazenamento de água no solo (mm)"
            yAxisId="soilWaterStorageVolume"
            type="monotone"
            dataKey="soilWaterStorageVolume"
            fill={theme.colors?.secondary}
          />
          <Tooltip {...tooltipProps} />
          <Legend
            verticalAlign="top"
            iconSize={theme.fontSizes[1]}
            wrapperStyle={{
              fontSize: theme.fontSizes[3],
              color: theme.colors.text,
            }}
            height={theme.space[9]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default React.memo(ChartSoilWaterStorage, (prevProps, nextProps) => {
  return (
    prevProps.data.length === nextProps.data.length &&
    prevProps.data.every(
      (item, index) =>
        item.soilWaterStorageVolume ===
        nextProps.data[index].soilWaterStorageVolume
    )
  );
});
